import { render, staticRenderFns } from "./data50.vue?vue&type=template&id=89c37714&scoped=true&"
import script from "./data50.vue?vue&type=script&lang=js&"
export * from "./data50.vue?vue&type=script&lang=js&"
import style1 from "./data50.vue?vue&type=style&index=1&id=89c37714&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89c37714",
  null
  
)

export default component.exports